import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { ReorderMarketingFlowStepsPayload } from "../../marketing.types";

export const requestReorderMarketingFlowSteps = async ({
  flowId,
  stepIds
}: ReorderMarketingFlowStepsPayload): Promise<{ ok: boolean }> => {
  return await instance.post(
    `${ApiRoutesMarketing.Flows}/${flowId}/steps/reorder`,
    { stepIds }
  );
};
